<div class="product-covered">
  <app-section-header [title]="'Product Covered'" />
  <form class="content" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-row" *ngFor="let formField of formFields; let i = index;"
      [ngClass]="{'col-8': (i === 1 || i===3), 'col-4': true}">
      <form-field [formField]="formField" [form]="form"> </form-field><span> <i class="pi pi-info-circle"
          *ngIf="i===0 || i===1"> </i></span>
    </div>
  </form>
</div>